import { render, staticRenderFns } from "./RegisterOrder.vue?vue&type=template&id=51ea5813&"
import script from "./RegisterOrder.vue?vue&type=script&lang=js&"
export * from "./RegisterOrder.vue?vue&type=script&lang=js&"
import style0 from "./RegisterOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports